import { render, staticRenderFns } from "./PerformanceManagement2.vue?vue&type=template&id=4fe9ce28&scoped=true&"
import script from "./PerformanceManagement2.vue?vue&type=script&lang=ts&"
export * from "./PerformanceManagement2.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceManagement2.vue?vue&type=style&index=0&id=4fe9ce28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe9ce28",
  null
  
)

export default component.exports